declare var jQuery: any;

import { Component, OnDestroy, AfterViewInit, ViewChild, ElementRef } from '@angular/core'
import { Subscription } from 'rxjs'
import { LoaderService } from '../../services/loader/loader.service'

import '@burt-ui/semantic/definitions/modules/dimmer.js'

@Component({
  selector: 'loader',
  template:
    `<div #elementRef class="ui transition dimmer">
      <div class="ui large indeterminate text loader">{{text}}</div>
    </div>`,
  styles:
  [`
    .ui.dimmer {
      position: fixed;
    }
  `],
  standalone: false
})
export class LoaderComponent implements OnDestroy, AfterViewInit {
  @ViewChild('elementRef') elementRef: ElementRef
  $element
  subscriptions: Subscription[]

  DEFAULT_TEXT = 'Loading'
  text: string

  constructor(private loaderService: LoaderService) { }

  ngAfterViewInit() {
    this.$element = $(this.elementRef.nativeElement)

    this.subscriptions = [
      this.loaderService.showEvent.subscribe(text => this.show()),
      this.loaderService.hideEvent.subscribe(() => this.hide()),
      this.loaderService.setTextEvent.subscribe(text => this.setText(text))
    ];
  }

  show() {
    this.$element.dimmer({closable: false})
    this.$element.dimmer('show')
  }

  hide() {
    this.$element.dimmer('hide')
  }

  setText(text: string = this.DEFAULT_TEXT) {
    this.text = text
  }

  ngOnDestroy() {
    this.subscriptions?.forEach(subscription => subscription.unsubscribe())
  }
}
